"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuList = exports.ChildRow = exports.ChildContainer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const menu_styled_1 = require("./menu.styled");
const clone_valid_element_1 = require("../../utils/clone-valid-element");
const base_react_components_1 = require("@navinc/base-react-components");
exports.ChildContainer = styled_components_1.default.ul.withConfig({ displayName: "reports-ChildContainer", componentId: "reports-3lqfcz" }) `
  margin-block: 0;
  padding-inline: 0;
  list-style-type: none;
  overflow: hidden;
  display: grid;
`;
exports.ChildRow = styled_components_1.default.li.withConfig({ displayName: "reports-ChildRow", componentId: "reports-1gkzsl6" }) `
  background-color: ${base_react_components_1.theme.neutral100};
  margin-top: ${({ isOpen }) => (isOpen ? '0%' : `-200%`)};
  transition: margin-top 0.3s ease-in-out;
  will-change: margin-top;

  ${menu_styled_1.StyledButton} {
    border-bottom: 1px solid ${base_react_components_1.theme.border};

    &:hover {
      border-bottom: 1px solid ${base_react_components_1.theme.border};
    }

    &:last-child {
      border-bottom: none;
    }
  }
`;
const MenuList = ({ isOpen = false, setIsSelected: setParentIsSelected, index = -1, children, currentLocation, section, }) => {
    const [selectedIndex, setIsSelected] = (0, react_1.useState)(-1);
    (0, react_1.useEffect)(() => {
        if (!isOpen) {
            setIsSelected(-1);
        }
        if (isOpen && selectedIndex !== -1) {
            setParentIsSelected && setParentIsSelected(index);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedIndex, isOpen]);
    return (react_1.default.createElement(exports.ChildContainer, { id: section },
        react_1.default.createElement(exports.ChildRow, { isOpen: isOpen }, react_1.default.Children.map(children, (child, index) => {
            return (0, clone_valid_element_1.cloneValidElement)(child, {
                isSelected: index === selectedIndex,
                setIsSelected,
                tabIndex: isOpen ? undefined : -1,
                index,
                currentLocation,
            });
        }))));
};
exports.MenuList = MenuList;
exports.MenuList.displayName = 'MenuList';
exports.default = exports.MenuList;
//# sourceMappingURL=menu-list.js.map